import angular from 'angular';
import InputComponent from './input.component';

const InputModule = angular
    .module('control-room.commons.form.components.input', [])
    .component('crInput', InputComponent);

export default InputModule;
